import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import PrivateRoute from './utils/PrivateRoute';
import Login from './components/login/Login';
import Main from './components/pages/Main';
// -- Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { faListUl } from '@fortawesome/free-solid-svg-icons'
import 'bootstrap/dist/css/bootstrap.min.css';
import './estilos/animations.css';
import './estilos/backgroundColors.css';
import './estilos/componentsStyles.css';
import './estilos/efects.css';
import './estilos/loaders.css';
import './estilos/positions.css';
import './estilos/scaleEffects.css';
import './estilos/sizes.css';
import './estilos/bg_sizes.css';
import './estilos/textColors.css';
import './estilos/backgroundGradients.css';
import './estilos/images.css';
import './estilos/fonts.css';

function App() {
  library.add(fab, faListUl);

  return (
    <BrowserRouter>
      <Switch>
        <Route path='/login' component={Login} />
        <PrivateRoute path='/' component={Main} />
      </Switch>
    </BrowserRouter>
  );
}

export default App;
